import React from "react";
import ErrorIcon from "./ErrorIcon/ErrorIcon";
import "./InputErrorMessage.css";

const InputErrorMessage = (props) => {
  return props.errorText ? (
    <p className="error-text">
      <span className="error-text-content">
        <ErrorIcon />
        {props.errorText}
      </span>
    </p>
  ) : null;
};

export default InputErrorMessage;
